// extracted by mini-css-extract-plugin
export default {"bioSection":"Bio_bioSection__ds6rW"};